import { api } from './client';
import { notifyNoteChanged } from '../utils/noteChanged';

function saved(storyId, request) {
  return Promise.resolve(request).then((result) => {
    notifyNoteChanged(storyId);
    return result;
  });
}

export const pendingOffersApi = {
  list: (storyId) => api.get(`/stories/${storyId}/pending-offers`),
  remember: (storyId, offers) => saved(storyId, api.post(`/stories/${storyId}/pending-offers/remember`, { offers })),
  accept: (storyId, body) => saved(storyId, api.post(`/stories/${storyId}/pending-offers/accept`, body)),
  reject: (storyId, body) => saved(storyId, api.post(`/stories/${storyId}/pending-offers/reject`, body)),
};
